import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Skeleton, styled } from '@mui/material';
import { AvatarSkeletonContainer } from './Avatar.style.js';
export const SmallAvatar = styled(Avatar, {
    shouldForwardProp: (prop) => prop !== 'size',
})(({ theme, size = 16 }) => ({
    background: theme.vars.palette.background.paper,
    width: size,
    height: size,
}));
export const SmallAvatarSkeleton = ({ size = 16 }) => {
    return (_jsx(AvatarSkeletonContainer, { children: _jsx(Skeleton, { width: size, height: size, variant: "circular" }) }));
};
//# sourceMappingURL=SmallAvatar.js.map